import React, { useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik as useFormic } from "formik";

import { UserLoginWithTwoFactor } from "../../../api/user";

import { AppDispatch } from "../../../slices/store";
import { userLoginChallengeThunk } from "../../../slices/thunk";
import { useAppDispatch, useAppSelector } from "../../../slices/hook";
import { getAuthState } from "../../../slices/auth/login/reducer";

import { RoutePath } from "../../../routes/route-path";
import LoadingComponent from "common/components/loader";

const OPTComponent = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser, error, sessionToken } = useAppSelector(getAuthState);

  useEffect(() => {
    if (loggedInuser?.id) {
      navigate(RoutePath.Admin_Dashborad_page);
    }
  }, [loggedInuser]);

  const inputRefs: any = {
    v1: useRef(null),
    v2: useRef(null),
    v3: useRef(null),
    v4: useRef(null),
    v5: useRef(null),
    v6: useRef(null),
  };

  const moveToNext = (currentField: number) => {
    if (currentField < 6) {
      const nextField = `v${currentField + 1}`;
      inputRefs[nextField].current.focus();
    }
  };

  const handleInputChange = (event: any, currentField: any) => {
    const { value } = event.target;
    // You can add validation or formatting logic here if needed
    if (value && value.length === 1) {
      moveToNext(currentField);
    }
  };

  const validation: any = useFormic({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      v1: "",
      v2: "",
      v3: "",
      v4: "",
      v5: "",
      v6: "",
    },
    validationSchema: Yup.object({
      v1: Yup.number().required(),
      v2: Yup.number().required(),
      v3: Yup.number().required(),
      v4: Yup.number().required(),
      v5: Yup.number().required(),
      v6: Yup.number().required(),
    }),

    onSubmit: (values: any) => {
      const _otp = `${values["v1"]}${values["v2"]}${values["v3"]}${values["v4"]}${values["v5"]}${values["v6"]}`;
      dispatch(
        userLoginChallengeThunk({
          username: loggedInuser?.username ?? "",
          password: "",
          twoFactorCode: _otp,
          sessionToken: sessionToken ?? "",
        })
      );
    },
  });

  return (
    <div>
      <div className="mt-8 text-center">
        <h4 className="mb-2 text-custom-500 dark:text-custom-500">Verify User</h4>
        <p className="mb-8 text-slate-500 dark:text-zink-200">
          Please enter the <b className="font-medium">6</b> digit code{" "}
        </p>
      </div>

      <form
        autoComplete="off"
        id="otpForm"
        onSubmit={(event: any) => {
          event.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <div className="grid grid-cols-1 gap-2 grid-cols-6">
          {[1, 2, 3, 4, 5, 6].map((index) => (
            <div key={index}>
              <label htmlFor={`v${index}`} className="hidden">
                Digit {index}
              </label>
              <input
                type="text"
                className="text-lg text-center form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                required
                placeholder=""
                maxLength={1}
                id={`v${index}`}
                name={`v${index}`}
                onBlur={validation.handleBlur}
                onChange={(e) => {
                  validation.handleChange(e);
                  handleInputChange(e, index);
                }}
                ref={inputRefs[`v${index}`]}
              />
            </div>
          ))}
        </div>
        <div className="mt-10">
          <button
            type="submit"
            className="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Confirm
          </button>
        </div>

        {error && (
          <div
            className="px-4 py-3 mt-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 
                       dark:bg-red-400/20 dark:border-red-500/50
                       text-center 
                       "
            id="successAlert"
          >
            You have <b>failed</b> signed in.
          </div>
        )}
        <div className="mt-10">{loading && <LoadingComponent />}</div>
      </form>
    </div>
  );
};

export default OPTComponent;
